<template>
  <v-list
    id="dashboard-menu"
    class="sidebar-menu is-active animated preFadeInRIght fadeInRight"
  >
    <MainMenuEntry
      v-for="entry in menuEntries"
      :key="entry.location.name"
      :icon-name="entry.iconName"
      :text="entry.text"
      :location="entry.location"
    />
  </v-list>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { brelagDeveloperRouteName } from '@/apps/brelag/brelag-developer/app'
import MainMenuEntry from '@/components/navigation/MainMenuEntry.vue'
import { i18n } from '@/lang/setup'

const menuEntries = computed(() => {
  return [
    {
      iconName: 'mdi-cellphone-link',
      text: i18n.global.t('apps.brelag.equipmentgroup', 2),
      location: { name: brelagDeveloperRouteName('equipment-group-root') },
    },
    {
      iconName: 'mdi-cellphone',
      text: i18n.global.t('apps.brelag.equipment', 2),
      location: { name: brelagDeveloperRouteName('equipment-root') },
    },
  ]
})
</script>

<style lang="scss"></style>
